// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { QbAdditionalContactDto } from './QbAdditionalContactDto';
import { QbCustomerContactDto } from './QbCustomerContactDto';
import { QbAdditionalNoteDto } from './QbAdditionalNoteDto';
import { QbDataExtensionDto } from './QbDataExtensionDto';
import { QbCustomerShipToAddressDto } from './QbCustomerShipToAddressDto';
import { QbCustomerDto } from './QbCustomerDto';

// AbilityIntranet.Data.Intranet.QbModels.QbCustomerFullDto
export class QbCustomerFullDto extends QbCustomerDto {
    public additionalContacts: QbAdditionalContactDto[] = [];
    public contacts: QbCustomerContactDto[] = [];
    public additionalNotes: QbAdditionalNoteDto[] = [];
    public dataExtensions: QbDataExtensionDto[] = [];
    public shipToAddresses: QbCustomerShipToAddressDto[] = [];
}


    



